import { FileShareWorkerRangeModel } from '../../microsoft/fileshare/file-share-worker-range-model';

export class FileShareWorkerRangesModel {
  ranges: FileShareWorkerRangeModel[];
  isDefault: boolean;
}
